// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import IUser from "./IUser"


export default class AnonymousUser implements IUser {

  getEmail(): string {
    throw Error("Not available for anonymous users.")
  }

  getDisplayName(): string {
    throw Error("Not available for anonymous users.")
  }

  getFamilyName(): string {
    throw Error("Not available for anonymous users.")
  }

  getFullDisplayName(): string {
    throw Error("Not available for anonymous users.")
  }

  getGivenName(): string {
    throw Error("Not available for anonymous users.")
  }

  isAuthenticated(): boolean {
    return false
  }

  isLoaded(): boolean {
    return true
  }

  signout(): Promise<void> { throw new Error("Not implemented.") }
}